module.exports = __webpack_public_path__ + "static/billboard-bg-video-2a7d0f9c1703b02d93a07b7d4c065096.mp4";